import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class PostVacantVehicleService {
  constructor(private http: HttpClient) {}
  
  postVehicle(data) {
    return this.http.post(environment.apiUrl + "vacant/vehicles/addNew", data);
  }
}